import { Box, IconButton, TableBody, TableCell, TableRow } from '@mui/material';
import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { CustomSelect } from '../../../../components/CustomSelect';
import { MAILING_HEAD_CELLS } from '../../constants/headCell';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import { DISABLED_CONTROL_TOOLTIP, MAILING_TYPE, PERMISSIONS } from '../../../../constants/variables';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ExpandLess } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';

export const MailingTableBody = (
  {
    data = [],
    templates,
    triggers,
    mailingTypes,
    updateRow,
    addRow,
    deleteRow,
    prefillRow = () => {},
    isEditable = true,
    isArchivedStatus = false,
    isActiveStatus = false,
    permissions,
  }) => {
  const [mailing, setMailing] = useState({});
  const [templateValue, setTemplateValue] = useState(null);
  const [templateTextExpanded, setTemplateTextExpanded] = useState([]);

  const addMailing = () => {
    if (!isAllowedToAddNewMailing) return;

    addRow({...mailing});
  }

  const removeMailing = (id) => {
    deleteRow(id);
  }

  const templatesOptions = mailing.mailingType ?
    templates.filter((template) => template.mailingType === mailing.mailingType.toLowerCase()) :
    templates;

  /*
  * @param fields: mailingType | triggerId | templateId
  * */
  const handlerOnChangeFooterSelect = (item, field) => {
    if (field === 'mailingType' && item.value !== mailing.mailingType) {
      setTemplateValue(null);
      setMailing({ mailingType: item.value, triggerId: mailing.triggerId });

      return;
    }

    if (field === 'templateId') {
      const templateOption = templatesOptions.find((option) => option.value === item.value);
      setTemplateValue(templateOption);
      setMailing({...mailing, [field]: item.value});

      if (isEditable && mailing.triggerId && mailing.mailingType) {
        prefillRow({ triggerId: mailing.triggerId, templateId: templateOption.value, mailingId: mailing.mailingType });
      }

      return;
    }

    setMailing({...mailing, [field]: item.value});

    if (isEditable && mailing.mailingType && templateValue) {
      prefillRow({ triggerId: item.value, templateId: templateValue.value, mailingId: mailing.mailingType });
    }
  };

  /*
  * @param fields: mailingType | triggerId | templateId
  * Fields for patch: mailing_id, mailing_template_id, mailing_trigger_id
  * */
  const handlerOnChangeBodySelect = (item, field, id) => {
    const foundMailing = data.find((row) => row.id === id);
    let templateId = foundMailing.mailing_template.id;
    let triggerId = foundMailing.mailing_trigger.id;

    if (field === 'mailingType' && item.value !== mailing.mailingType) {
      const foundFirstMailingByType = data.find((row) => row.mailing_template.mailing_type === item.value.toLowerCase());

      if (foundFirstMailingByType) {
        templateId = foundFirstMailingByType.mailing_template.id;
      }
    }
    if (field === 'templateId') {
      templateId = item.value;
    }
    if (field === 'triggerId') {
      triggerId = item.value;
    }

    updateRow({mailingId: id, templateId, triggerId});
  }

  const isAllowedToAddMailingToCreatedBonus = visibleBySectionPermission(permissions, PERMISSIONS.MAILING.CreateBonusCardCreatedMailingTemplates.value);
  const isAllowedToAddMailingToActiveBonus = visibleBySectionPermission(permissions, PERMISSIONS.MAILING.CreateBonusCardActiveMailingTemplates.value);
  const isAllowedToDeleteMailingToCreatedBonus = visibleBySectionPermission(permissions, PERMISSIONS.MAILING.DeleteBonusCardCreatedMailingTemplates.value);
  const isAllowedToDeleteMailingToActiveBonus = visibleBySectionPermission(permissions, PERMISSIONS.MAILING.DeleteBonusCardActiveMailingTemplates.value);

  const isAllowedToAddNewMailing = Object.keys(mailing).length === 3;  // 3 required fields: mailingType, triggerId, templateId
  const isAllowedToAddNewMailingByPermission = isActiveStatus ? isAllowedToAddMailingToActiveBonus : isAllowedToAddMailingToCreatedBonus;
  const isAllowedToDeleteMailingByPermission = isActiveStatus ? isAllowedToDeleteMailingToActiveBonus : isAllowedToDeleteMailingToCreatedBonus;

  const overlappedTextLimit = 115;
  const isTemplateTextOverlapped = (item) => item?.text.length > overlappedTextLimit;

  return (
    <TableBody data-testid="TableBody">
      {
        data.map((item) => (
          <TableRow key={item.id} data-testid="TableRowAdded">
            {
              isEditable ? (
                <>
                  <TableCell>
                    <CustomSelect
                      name={MAILING_HEAD_CELLS[0].id}
                      options={mailingTypes}
                      value={MAILING_TYPE[item.mailing_template?.mailing_type.toUpperCase()]}
                      onChange={(e) => handlerOnChangeBodySelect(e, 'mailingType', item.id)}
                      sx={{ width: '180px' }}
                      required
                    />
                  </TableCell>
                  <TableCell>
                    <CustomSelect
                      name={MAILING_HEAD_CELLS[1].id}
                      options={triggers}
                      value={item.mailing_trigger?.name}
                      onChange={(e) => handlerOnChangeBodySelect(e, 'triggerId', item.id)}
                      sx={{ width: '240px' }}
                      required
                    />
                  </TableCell>
                  <TableCell>
                    <CustomSelect
                      name={MAILING_HEAD_CELLS[2].id}
                      options={templatesOptions}
                      value={item.mailing_template?.name}
                      onChange={(e) => handlerOnChangeBodySelect(e, 'templateId', item.id)}
                      sx={{ width: '240px' }}
                      required
                    />
                  </TableCell>
                </>
              ) : (
                <>
                  <TableCell>
                    { MAILING_TYPE[item.mailing_template.mailing_type?.toUpperCase()] }
                  </TableCell>
                  <TableCell>
                    { item.mailing_trigger.name }
                  </TableCell>
                  <TableCell>
                    { item.mailing_template.name }
                  </TableCell>
                </>
              )
            }
            <TableCell sx={{ position: 'relative' }}>
              {
                isTemplateTextOverlapped(item.mailing_template) ?
                  !templateTextExpanded.includes(item.id) ? (
                    <Box
                      sx={{
                        paddingRight: '30px',
                        maxWidth: '328px',
                        width: '100%',
                        maxHeight: '65px',
                        overflow: 'hidden',
                        cursor: 'default',
                      }}
                    >
                      {item.mailing_template?.text.slice(0, overlappedTextLimit)}&#x2026;
                      <Box component="span"
                           onClick={
                             () => setTemplateTextExpanded([...templateTextExpanded, item.id])
                           }
                           sx={{ position: 'absolute', bottom: 0, right: -5 }}
                           data-testid="ExpandBlock"
                      >
                        <IconButton><ExpandMoreIcon /></IconButton>
                      </Box>
                    </Box>
                  ) : (
                    <Box>
                      {item.mailing_template?.text}
                      <Box component="span"
                           onClick={
                             () => setTemplateTextExpanded(templateTextExpanded.filter((id) => id !== item.id))
                           }
                           sx={{ position: 'absolute' }}
                           data-testid="CollapseBlock"
                      >
                        <IconButton><ExpandLess /></IconButton>
                      </Box>
                    </Box>
                  ) : (
                    <Box>{item.mailing_template?.text}</Box>
                  )
              }
            </TableCell>
            {
              isEditable ? (
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Box>
                      {
                        isAllowedToDeleteMailingByPermission ? (
                          <IconButton onClick={() => removeMailing(item.id)} data-testid="RemoveButton">
                            <CloseIcon htmlColor={'red'} />
                          </IconButton>
                        ) : (
                          <Tooltip title={DISABLED_CONTROL_TOOLTIP} sx={{pointerEvents: 'auto', cursor: 'not-allowed'}} arrow>
                            <Box>
                              <IconButton disabled={true} data-testid="RemoveButton">
                                <CloseIcon htmlColor={'grey[1000]'} />
                              </IconButton>
                            </Box>
                          </Tooltip>
                        )
                      }
                    </Box>
                  </Box>
                </TableCell>
              ) : (
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Box>
                      {
                        isAllowedToDeleteMailingByPermission ? (
                          <IconButton onClick={() => removeMailing(item.id)} disabled={isArchivedStatus} data-testid="RemoveButton">
                            <CloseIcon htmlColor={isArchivedStatus ? 'grey[1000]' : 'red'} />
                          </IconButton>
                        ) : (
                          <Tooltip title={DISABLED_CONTROL_TOOLTIP} sx={{pointerEvents: 'auto', cursor: 'not-allowed'}} arrow>
                            <Box>
                              <IconButton disabled={true} data-testid="RemoveButton">
                                <CloseIcon htmlColor='grey[1000]' />
                              </IconButton>
                            </Box>
                          </Tooltip>
                        )
                      }
                    </Box>
                  </Box>
                </TableCell>
              )
            }
          </TableRow>
        ))
      }

      <TableRow data-testid="TableRowSelect">
        <TableCell height={48}>
          {
            isAllowedToAddNewMailingByPermission ? (
              <CustomSelect
                name={MAILING_HEAD_CELLS[0].id}
                onChange={(e) => handlerOnChangeFooterSelect(e, 'mailingType')}
                options={mailingTypes}
                placeholder="Выберите тип"
                sx={{ width: '180px' }}
                disabled={isArchivedStatus}
              />
            ) : (
              <CustomSelect
                name={MAILING_HEAD_CELLS[0].id}
                options={mailingTypes}
                placeholder="Выберите тип"
                sx={{ width: '180px' }}
                disabled={true}
                tooltip={DISABLED_CONTROL_TOOLTIP}
              />
            )
          }
        </TableCell>
        <TableCell height={48}>
          {
            isAllowedToAddNewMailingByPermission ? (
              <CustomSelect
                name={MAILING_HEAD_CELLS[1].id}
                onChange={(e) => handlerOnChangeFooterSelect(e, 'triggerId')}
                options={triggers}
                placeholder="Выберите триггер"
                sx={{ width: '240px' }}
                disabled={isArchivedStatus}
              />
            ) : (
              <CustomSelect
                name={MAILING_HEAD_CELLS[1].id}
                options={triggers}
                placeholder="Выберите триггер"
                sx={{ width: '240px' }}
                disabled={true}
                tooltip={DISABLED_CONTROL_TOOLTIP}
              />
            )
          }
        </TableCell>
        <TableCell height={48}>
          {
            isAllowedToAddNewMailingByPermission ? (
              <CustomSelect
                name={MAILING_HEAD_CELLS[2].id}
                onChange={(e) => handlerOnChangeFooterSelect(e, 'templateId')}
                options={templatesOptions}
                placeholder="Выберите шаблон"
                sx={{ width: '240px' }}
                value={templateValue}
                disabled={isArchivedStatus}
              />
            ) : (
              <CustomSelect
                name={MAILING_HEAD_CELLS[2].id}
                options={templatesOptions}
                placeholder="Выберите шаблон"
                sx={{ width: '240px' }}
                value={templateValue}
                disabled={true}
                tooltip={DISABLED_CONTROL_TOOLTIP}
              />
            )
          }
        </TableCell>
        <TableCell height={48} colSpan={2}>
          {
            templateValue?.text ?
              templateValue.text.length > 128 ?
                (
                <Tooltip title={templateValue.text} arrow sx={{pointerEvents: 'auto'}}>
                  <Box
                    sx={{
                      maxWidth: '328px',
                      width: '100%',
                      maxHeight: '65px',
                      overflow: 'hidden',
                      cursor: 'default',
                    }}
                  >
                    {templateValue.text.slice(0, 128)}&#x2026;
                  </Box>
                </Tooltip>
              ) : (
              <Box>{templateValue.text}</Box>
              ) : null
          }
        </TableCell>
      </TableRow>

      <TableRow data-testid="TableRowAdd">
        <TableCell colSpan={5} data-testid="AddMailing" sx={{ border: 'none' }}>
          {
            !isAllowedToAddNewMailingByPermission ? (
              <Tooltip title={DISABLED_CONTROL_TOOLTIP} sx={{pointerEvents: 'auto'}} arrow>
                <Box
                  sx={{ flexGrow: 1, display: 'inline-flex', cursor: 'not-allowed' }}
                  disabled={true}
                  color={"grey[1000]"}
                  data-testid="TypePlaceholder"
                >
                  <Box
                    component={AddIcon}
                    disabled={true}
                    color={"grey[1000]"}
                    sx={{ mr: 1 }}
                  />
                  Добавить рассылку
                </Box>
              </Tooltip>
            ) : (
              <Box
                sx={{ flexGrow: 1, display: 'inline-flex', cursor: isAllowedToAddNewMailing ? 'pointer' : 'not-allowed' }}
                onClick={() => addMailing()}
                disabled={!isAllowedToAddNewMailing || isArchivedStatus}
                color={isAllowedToAddNewMailing && !isArchivedStatus ? "primary.main" : "grey[1000]"}
                data-testid="TypePlaceholder"
              >
                <Box
                  component={AddIcon}
                  disabled={!isAllowedToAddNewMailing || isArchivedStatus}
                  color={isAllowedToAddNewMailing && !isArchivedStatus ? "primary.main" : "grey[1000]"}
                  sx={{ mr: 1 }}
                />
                Добавить рассылку
              </Box>
            )
          }
        </TableCell>
      </TableRow>
    </TableBody>
  );
}

MailingTableBody.propTypes = {
  data: PropTypes.array,
  templates: PropTypes.array,
  triggers: PropTypes.array,
  mailingTypes: PropTypes.array,
  addRow: PropTypes.func,
  prefillRow: PropTypes.func,
  updateRow: PropTypes.func,
  deleteRow: PropTypes.func,
  isEditable: PropTypes.bool,
  isArchivedStatus: PropTypes.bool,
  isActiveStatus: PropTypes.bool,
  permissions: PropTypes.array,
};
